import moment from 'moment'
import store from 'src/store'
import { multiSelect } from 'src/common/selectors'
import { obterDataValida } from 'src/utils/formatadoras/formatadoras'
import { TipoDeUsuario } from './utils'
import { periodoPadraoDeSolicitacoes } from './formulario/entradaPelaConversa'

function defaultState() {
  return {
    ...multiSelect.mapStates(['companies', 'employees', 'userGroups', 'perfis']),
    ...periodoPadraoDeSolicitacoes(),
    allApprovals: [],
    abaSelecionada: TipoDeUsuario.Lider,
    buscarDadosTelaInicial: false,
    // Corpo da requisição para buscar aprovações pessoais
    // @example
    // requisicaoPessoal: {
    //   tipoDeEvento: null,
    //   status: null,
    //   entidades: {
    //     tipo: null,
    //     ids: null,
    //   },
    //   utilizar_data_de_criacao_da_solicitacao: null,
    //   dataInicial: null,
    //   dataFinal: null,
    // }
    requisicaoPessoal: { },
    // Corpo da requisição para buscar aprovações de liderados
    // @example
    // requisicaoLider: {
    //   tipoDeEvento: null,
    //   status: null,
    //   entidades: {
    //     tipo: null,
    //     ids: null,
    //     todos: false,
    //   },
    //   utilizar_data_de_criacao_da_solicitacao: null,
    //   dataInicial: null,
    //   dataFinal: null,
    // }
    requisicaoLider: {}
  }
}

const mutations = {
  ...multiSelect.mapMutations(['companies', 'employees', 'userGroups', 'perfis']),
  startDate: (state, payload) => { state.startDate = obterDataValida(payload) },
  endDate: (state, payload) => { state.endDate = obterDataValida(payload) },
  abaSelecionada(state, payload) { state.abaSelecionada = payload },
  allApprovals(state, payload) { state.allApprovals = payload },
  atualizarApenarUmaSolicitacao(state, { solicitacao, indice }) { state.allApprovals.splice(indice, 1, solicitacao) },
  buscarDadosTelaInicial(state, payload) { state.buscarDadosTelaInicial = payload },
  requisicaoPessoal(state, payload) { state.requisicaoPessoal = payload },
  requisicaoLider(state, payload) { state.requisicaoLider = payload }
}

const getters = {
  dataDeMigracaoParaNovoModuloDeSolicitacoes() {
    if (!store.state.userInfo?.compMan?.dataDeMigracaoParaNovoModuloDeAprovacoes) {
      return null
    }
    return moment.utc(store.state.userInfo.compMan.dataDeMigracaoParaNovoModuloDeAprovacoes)
  }
}

export default {
  namespaced: true,
  state: defaultState(),
  getters,
  mutations
}
